import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CommonModal from "../modal/CommonModal";
import Icons from "../iconMaster/Icons";
import { Link } from "react-router-dom";

const HomeEnquiry = ({
    showConfirmation,
    setShowConfirmation
}: any) => {
    return (
        <>
            <CommonModal
                show={showConfirmation}
                onHide={() => setShowConfirmation(false)}
                size="md"
                showFooter={false}
                contentClassName="custom-modal ar_popup_bg bg-light inter-regular text-center"
                showHeader={false}
            >
                <button
                    type="button"
                    className="btn-close custom-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        setShowConfirmation(false);
                    }}
                ></button>
                
                <Icons name="confirm-icon" width="122" height="57" />
                <h1 className="fs-3 fw-bolder mt-3" style={{ color: "#49963F" }}>Enquiry Received!</h1>
                <h4 className="fs-5 fw-bold fst-italic">Thank you for contacting Genius World.</h4>
                <p>Our team will reach out shortly with tailored holiday options.</p>
                <Link className="animated-btn btn btn-shadow m-auto px-5 rounded-5" to="/">Back to Home</Link>

            </CommonModal>
        </>
    )
}
export default HomeEnquiry;